const API_BASE = '/api/';

const API = {

  AUTHENTICATE                  : 'auth/authenticate',
  EXT_AUTHENTICATE_METADATA     : 'auth/ext-authenticate-metadata',
  EXT_AUTHENTICATE              : 'auth/ext-authenticate',
  SET_PASSWORD                  : 'user/set-password',
  CHANGE_PASSWORD               : 'user/change-password',
  CHANGE_PASSWORD_FIRST_TIME_EXT: 'user/change-password-first-time',
  REQEST_RESET_PASSWORD         : 'user/reset-password',
  PASS_VALIDATION_RULES         : 'password-validation-rules',

  CREATE_USER                         : 'user/create-user',
  CREATE_USER_WITH_ROLES              : 'user/create-user-with-roles',
  CHECK_USER_EXIST                    : 'user/user-exists',
  UPDATE_USER                         : 'user/update-user',
  DELETE_USER                         : 'user/delete-user',
  GET_USER                            : 'user/get-user',
  GET_USER_PROFILE                    : 'user/get-user-profile',
  GET_CURRENT_USER                    : 'user/get-current-user',
  VALIDATE_USER                       : 'user/validate-user',
  ACTIVATE_USER                       : 'user/activate-user',
  INVITE_USER                         : 'user/invite-user',
  VERIFY_INVITATION                   : 'user/verify-invitation',
  ACCEPT_INVITATION                   : 'user/accept-invitation',
  FIND_USERS                          : 'user/find-users',
  UPDATE_PROFILE                      : 'user/update-profile',
  GET_USER_GROUPS                     : 'user/get-external-user-groups',
  GET_USER_ORG_SUGGESTIONS            : 'user/get-external-user-organizations',
  GET_USER_COUNTRIES                  : 'user/get-countries',
  GET_USER_TERRITORIES                : 'user/get-territories',
  GET_UNLOCK_REASONS                  : 'user/get-unlock-user-reasons',
  UNLOCK_USER                         : 'user/unlock-user',
  FORCE_RESET_PASSWORD                : 'user/force-change-password',
  GET_EXTERNAL_ORGANIZATIONS_HIERARCHY: 'user/get-external-organizations-hierarchy',
  GET_ORG_DEFAULT_ROLES               : 'user/get-default-role',
  GET_ORGANIZATIONS_BY_COUNTRIES      : 'user/get-organizations-by-countries',
  ASSIGN_ROLES_TO_ORGANIZATION        : 'user/assigned-roles-to-organization',
  GET_ORGANIZATIONS_BY_SEARCH_CRITERIA: 'user/get-organizations-by-searchCriteria',
  GET_ORGANIZATIONS_BY_ROLES          : 'user/get-organizations-by-roles',
  GET_USERS_BY_ORGANIZATION           : 'user/get-users-by-organization',
  REMOVE_ROLES_FROM_ORGANIZATIONS     : 'user/unassigned-roles-from-organization',
  GET_USER_METADATA                   : 'user/user-metadata',
  FORCE_USER_ACTIVATE                 : 'user/force-user-activate',
  GET_USER_PROFILE_METADATA           : 'user/user-profile-metadata',

  APP_ACCESS                    : 'access/applications',
  GET_AIRLINES                  : 'access/get-airlines',
  GET_MICROPRODUCTS             : 'access/get-microproducts',
  ROLE_NAME_EXIST               : 'access/has-role',
  GET_USER_ROLES                : 'access/get-user-roles',
  ASSIGN_USER_ROLES             : 'access/assign-user-roles',
  USERS_ASSIGNED_TO_ROLE        : 'access/users-assigned-to-role',
  AVAILABLE_ROLE_NAMES          : 'access/available-role-names',
  CREATE_ROLE                   : 'access/create-role',
  FIND_ROLES                    : 'access/find-roles',
  GET_ROLE                      : 'access/get-role',
  UPDATE_ROLE                   : 'access/update-role',
  DELETE_ROLE                   : 'access/delete-role',
  SET_ROLE_STATUS               : 'access/set-role-status',
  GET_ALL_EXTERNAL_ROLES        : 'access/get-active-external-roles',
  GET_ROLES_FOR_ORGANIZATIONS   : 'access/get-roles-for-organizations',
};
// add that here because addBaseUrl function works only with strings
export const GET_SESSION_HISTORY = userId => `${API_BASE}auth/user/${userId}/history`;
export const GET_USER_AUDIT_LOG_VERSIONS = login => `${API_BASE}user/${login}/versions`;
export const GET_USER_AUDIT_LOG = (login,version) => `${API_BASE}user/log/${login}/${version}`;
export const GET_ROLE_AUDIT_LOG_VERSIONS = login => `${API_BASE}access/${login}/versions`;
export const GET_ROLE_AUDIT_LOG = (login,version) => `${API_BASE}access/log/${login}/${version}`;

const addBaseUrl = urls =>
  Object.keys(urls).reduce((api, name) => {
    api[name] = API_BASE + urls[name];
    return api;
  }, {});

export default addBaseUrl(API);
